import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadMeldungTerminRegelListStatus: 'idle',
    loadMeldungTerminRegelListError: undefined as any,
    loadMeldungTerminRegelListLastArgs: undefined as any,
    loadMeldungTerminRegelStatus: 'idle',
    loadMeldungTerminRegelError: undefined as any,
    saveMeldungTerminRegelStatus: 'idle',
    saveMeldungTerminRegelError: undefined as any,
    deleteMeldungTerminRegelStatus: 'idle',
    deleteMeldungTerminRegelError: undefined as any,

    meldungTerminRegelList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadMeldungTerminRegelList = createAsyncThunk('meldungTerminRegelSlice/loadMeldungTerminRegelList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().meldungTerminRegelSlice.loadMeldungTerminRegelListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurismeldtermregel/?action=gte&MIN_MELDUNGID=${parentModel.HDR_ID}&MAX_MELDUNGID=${parentModel.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadMeldungTerminRegelListStatus } = getState().meldungTerminRegelSlice
        return loadMeldungTerminRegelListStatus !== 'pending'
    }
})

export const loadMeldungTerminRegel = createAsyncThunk('meldungTerminRegelSlice/loadMeldungTerminRegel', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurismeldtermregel/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadMeldungTerminRegelStatus } = getState().meldungTerminRegelSlice
        return loadMeldungTerminRegelStatus !== 'pending'
    }
})

export const saveMeldungTerminRegel = createAsyncThunk('meldungTerminRegelSlice/saveMeldungTerminRegel', async ({ meldungTerminRegel }: any, { rejectWithValue }: any) => {
    let promises = []
    if (meldungTerminRegel?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nurismeldtermregel/${ meldungTerminRegel?.HDR_ID }/`,
            prepareData(meldungTerminRegel),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nurismeldtermregel/`,
            prepareData(meldungTerminRegel),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveMeldungTerminRegelStatus } = getState().meldungTerminRegelSlice
        return saveMeldungTerminRegelStatus !== 'pending'
    }
})

export const deleteMeldungTerminRegel = createAsyncThunk('meldungTerminRegelSlice/deleteMeldungTerminRegel', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/nurismeldtermregel/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteMeldungTerminRegelStatus } = getState().meldungTerminRegelSlice
        return deleteMeldungTerminRegelStatus !== 'pending'
    }
})

const MeldungTerminRegelSlice = createSlice({
    name: 'meldungTerminRegelSlice',
    initialState,
    reducers: {
        resetloadMeldungTerminRegelListError: (state) => {
            state.loadMeldungTerminRegelListError = undefined
        },
        resetloadMeldungTerminRegel: (state) => {
            state.formItem = undefined
            state.loadMeldungTerminRegelError = undefined
        },
        resetloadMeldungTerminRegelError: (state) => {
            state.loadMeldungTerminRegelError = undefined
        },
        resetsaveMeldungTerminRegel: (state) => {
            state.formItem = undefined
            state.saveMeldungTerminRegelError = undefined
        },
        resetsaveMeldungTerminRegelError: (state) => {
            state.saveMeldungTerminRegelError = undefined
        },
        resetdeleteMeldungTerminRegelError: (state) => {
            state.deleteMeldungTerminRegelError = undefined
        },
        removeFromMeldungTerminRegelListById: (state, action) => {
            state.meldungTerminRegelList = state.meldungTerminRegelList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromMeldungTerminRegelListByIds: (state, action) => {
            state.meldungTerminRegelList = state.meldungTerminRegelList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.meldungTerminRegelList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadMeldungTerminRegelListStatus = 'preloaded'
            state.loadMeldungTerminRegelListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.meldungTerminRegelList = []
            state.loadMeldungTerminRegelListStatus = 'idle'
            state.loadMeldungTerminRegelListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadMeldungTerminRegelList.pending, (state) => {
            state.loadMeldungTerminRegelListStatus = 'pending'
            state.loadMeldungTerminRegelListError = undefined
        })
        builder.addCase(loadMeldungTerminRegelList.fulfilled, (state, action) => {
            state.loadMeldungTerminRegelListStatus = 'idle'

            if (!action.payload) { return }

            state.loadMeldungTerminRegelListLastArgs = action.payload.args

            {
                state.meldungTerminRegelList = action.payload.data

            }
        })
        builder.addCase(loadMeldungTerminRegelList.rejected, (state, action) => {
            state.loadMeldungTerminRegelListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMeldungTerminRegelListError = action.error.message
            } else {
                state.loadMeldungTerminRegelListError = action.payload
            }
        })

        builder.addCase(loadMeldungTerminRegel.pending, (state) => {
            state.loadMeldungTerminRegelStatus = 'pending'
            state.loadMeldungTerminRegelError = undefined
        })
        builder.addCase(loadMeldungTerminRegel.fulfilled, (state, action) => {
            state.loadMeldungTerminRegelStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.meldungTerminRegelList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.meldungTerminRegelList.push(newItem) }
                else { state.meldungTerminRegelList[i] = { ...state.meldungTerminRegelList[i], ...newItem } }
            }
        })
        builder.addCase(loadMeldungTerminRegel.rejected, (state, action) => {
            state.loadMeldungTerminRegelStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMeldungTerminRegelError = action.error.message
            } else {
                state.loadMeldungTerminRegelError = action.payload
            }
        })

        builder.addCase(saveMeldungTerminRegel.pending, (state) => {
            state.saveMeldungTerminRegelStatus = 'pending'
            state.saveMeldungTerminRegelError = undefined
        })
        builder.addCase(saveMeldungTerminRegel.fulfilled, (state, action) => {
            state.saveMeldungTerminRegelStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.meldungTerminRegelList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.meldungTerminRegelList.push(newItem) }
                else { state.meldungTerminRegelList[i] = { ...state.meldungTerminRegelList[i], ...newItem } }
            }
        })
        builder.addCase(saveMeldungTerminRegel.rejected, (state, action) => {
            state.saveMeldungTerminRegelStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveMeldungTerminRegelError = action.error.message
            } else {
                state.saveMeldungTerminRegelError = action.payload
            }
        })

        builder.addCase(deleteMeldungTerminRegel.pending, (state) => {
            state.deleteMeldungTerminRegelStatus = 'pending'
            state.deleteMeldungTerminRegelError = undefined
        })
        builder.addCase(deleteMeldungTerminRegel.fulfilled, (state, action) => {
            state.deleteMeldungTerminRegelStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.meldungTerminRegelList = state.meldungTerminRegelList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.meldungTerminRegelList = state.meldungTerminRegelList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteMeldungTerminRegel.rejected, (state, action) => {
            state.deleteMeldungTerminRegelStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteMeldungTerminRegelError = action.error.message
            } else {
                state.deleteMeldungTerminRegelError = action.payload
            }
        })

    }
})

export const {
    resetloadMeldungTerminRegelListError,
    resetloadMeldungTerminRegel,
    resetloadMeldungTerminRegelError,
    resetsaveMeldungTerminRegel,
    resetsaveMeldungTerminRegelError,
    resetdeleteMeldungTerminRegelError,
    removeFromMeldungTerminRegelListById,
    removeFromMeldungTerminRegelListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = MeldungTerminRegelSlice.actions
export default MeldungTerminRegelSlice.reducer
